"use client"

import * as React from "react"

import { Progress } from "@/components/ui/progress"

export function ProgressAnimated({ className, value }) {
  const [progress, setProgress] = React.useState(0)

  React.useEffect(() => {
    const timer = setTimeout(() => setProgress(value), 300)
    return () => clearTimeout(timer)
  }, [])

  return <Progress value={progress} className={className} />
}
